export const AutoDispatchRouting = [
  {
    path: "/maintenance/autoDispatch",
    name: "maintenance-autoDispatch-list",
    meta: { title: "自动派单规则" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-autoDispatch" */ "@/views/maintenance/autoDispatch/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/autoDispatch/create",
    name: "maintenance-autoDispatch-create",
    meta: { title: "新建自动派单规则", comName: "autoDispatchFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-autoDispatch" */ "@/views/maintenance/autoDispatch/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/autoDispatch/edit/:id",
    name: "maintenance-autoDispatch-edit",
    meta: { title: "编辑自动派单规则", comName: "autoDispatchFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-autoDispatch" */ "@/views/maintenance/autoDispatch/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/autoDispatch/detail/:id",
    name: "maintenance-autoDispatch-detail",
    meta: { title: "自动派单规则详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-autoDispatch" */ "@/views/maintenance/autoDispatch/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/autoDispatch/flowPrint/:id",
    name: "maintenance-autoDispatch-flow-print",
    meta: { title: "自动派单规则打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-autoDispatch" */ "@/views/maintenance/autoDispatch/flow-print/index.vue"
      ),
  },
];
